export const usersCreateSteps = [
  {
    target: ".j_u_bBtn",
    content:
      "Click here to go back to the full list of users without saving your current changes.",
    placement: "bottom",
  },
  {
    target: ".j_u_save",
    content:
      "Click 'Save' to store the user's information and remain on this page for further editing.",
    placement: "left",
  },
  {
    target: ".j_u_sa_cl",
    content:
      "Click 'Save & Close' to store the user’s information and return to the user list.",
    placement: "left",
  },
   {
    target: ".j_u_ac_mtr",
    content:
      "This meter will display the overall access level of the user once roles are assigned, based on the combined weight of those roles.",
    placement: "left",
  },
];

export const userCreateDetailsSteps = [
  {
    target: ".j_u_details",
    content:
      "This 'Details' tab contains all the mandatory fields needed to create a new user. Start by filling out the fields below.",
    placement: "bottom",
  },
  {
    target: ".j_u_status",
    content:
      "Use this toggle to set the user status as Active or Inactive. Active users can log in and use the system.",
    placement: "bottom",
  },
  {
    target: ".j_u_uNam",
    content:
      "Begin by selecting an existing user from Active Directory using this dropdown. This field is required.",
    placement: "bottom",
  },
  {
    target: ".j_u_ad_tgl",
    content:
      "Use this toggle to indicate if the user is from Active Directory. It should be enabled for domain-linked users.",
    placement: "bottom",
  },
  {
    target: ".j_u_ap_acc",
    content:
      "Choose the level of application access for this user. For example, 'User' for standard access or 'Admin' for elevated permissions.",
    placement: "bottom",
  },
  {
    target: ".j_u_fname",
    content:
      "Enter the first name of the user. This is a required field and helps identify the user clearly.",
    placement: "bottom",
  },
  {
    target: ".j_u_lname",
    content:
      "Enter the user's last name. This field is optional but helps provide the full user identity.",
    placement: "bottom",
  },
  {
    target: ".j_u_mail",
    content:
      "Input a valid email address for the user. This is mandatory for communication and account recovery.",
    placement: "bottom",
  },
  {
    target: ".j_u_mngr",
    content:
      "Assign a reporting manager for this user by selecting from the list. This helps in organizing team structures.",
    placement: "bottom",
  },

];
export const userCreateRoleSteps = [
  {
    target: '.j_u_roles',
    content: 'This is the Roles tab where you manage user access through role assignments.',
    placement: 'bottom',
  },
{
    target: ".j_srch",
    content:
      "Filter results based on name, ID, or other attributes depending on the field.",
    placement: "bottom",
  },
  {
    target: ".j_fil",
    content:
      "Filter results based on the dimension names.",
    placement: "bottom",
  },
  {
    target: '.j_u_rT_assigned',
    content: 'Assigned roles for the user will appear here.',
    placement: 'bottom',
  },
  {
    target: '.j_u_rT_available',
    content: 'Click here to view and assign new roles from the available ones.',
    placement: 'bottom',
  },
  {
    target: '.j_u_rT_groups',
    content: 'You can assign Security Groups to the user from this section.',
    placement: 'bottom',
  },
  {
    target: '.j_g_rt_copy',
    content: 'Copy roles from an existing user or security group to save time.',
    placement: 'top',
  },
  {
    target: '.j_g_rT_asBtn',
    content: 'Use this button to assign roles to the user manually.',
    placement: 'top',
  }
];
export const userCreateReportSteps = [
  {
    target: ".j_u_rep",
    content: "This tab shows all the scheduled reports configured for this user.",
    placement: "bottom",
  },
  {
    target: ".j_u_r_srch",
    content: "Use this field to search for a report by name.",
    placement: "bottom",
  },

  {
    target: ".j_u_r_card",
    content:
      "Each card here represents a scheduled report, with its name and creation details.",
    placement: "bottom",
  },
  {
    target: ".j_u_r_rem",
    content:
      "Click this icon to remove user being created from the distribution list for this report.",
    placement: "left",
  },
];


